import fetch from '@/api/fetch'

/**
 * 获取个人浏览记录
 * @param {Object} params - 无
 */
export function getPosterInfo(params) {
  return fetch({
    url: '/v3/footmark/index',
    params
  })
}
